<!--客户管理 - 客户列表 查看项目点-->
<template>
  <div>
    <el-row style="margin-bottom: -20px;">
      <h4>客户名称：{{ customerName }}</h4>
    </el-row>
    <el-row>
      <el-form size="small" :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:20px"
        :model="searchForm" ref="searchForm">
        <el-col :xl="5" :lg="10" :md="10" :xs="10" :sm="10">
          <el-form-item label="名称：">
            <el-input size="medium" placeholder="名称" minlength="2" maxlength="10" v-model="searchForm.NAME" clearable
              @keyup.enter.native="handleSearch()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xl="5" :lg="8" :md="12">
          <el-form-item label="状态：">
            <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：</label>
            <el-select size="medium" filterable v-model="searchForm.STATUS" placeholder="请选择" clearable>
              <el-option v-for="item in STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="handleSearch()"
              :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24" style="margin-bottom:10px">
        <el-button size="medium" @click="openAdd" v-show="customerStatus !== 1">新增</el-button>
        <el-button size="medium" @click="commodityBindForm">批量绑定供应商</el-button>
        <el-button size="medium" type="primary" plain @click="exportProject" v-if="userPriceType == 2">导出</el-button>
        <el-button size="medium" @click="matchProject" v-if="canSelfEntryOrders">匹配项目点</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="projectSitesListData" border stripe style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="ID" label="项目点ID"></el-table-column>
          <el-table-column prop="NAME" label="项目点名称" width="150"></el-table-column>
          <el-table-column prop="CODE" label="名称缩写" width="150"></el-table-column>
          <el-table-column prop="CITY" label="城市" min-width="150"></el-table-column>
          <el-table-column prop="ADDRESS" label="详细地址" min-width="150"></el-table-column>
          <el-table-column label="客户类型" min-width="150">
            <template slot-scope="scope">
              <span>{{ customerTypeLists[scope.row.CUSTOMER_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="MANAGER_NAME" label="负责人" min-width="150"></el-table-column>
          <el-table-column prop="MANAGER_CELLPHONE" label="联系电话" min-width="150"></el-table-column>
          <el-table-column label="扣点" prop="ADD_POINT"></el-table-column>
          <!-- <el-table-column label="是否为内部部门" min-width="150">
            <template slot-scope="scope">
              <span>{{ showDepartment[scope.row.BE_INNER_DEPARTMENT] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否计入销售" min-width="150">
            <template slot-scope="scope">
              <span>{{ showSell[scope.row.BE_SALE_COUNT] }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="是否需要检测报告" min-width="150">
            <template slot-scope="scope">
              <span>{{ showFTS[scope.row.NEED_FTS] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="打印是否带价格" min-width="150">
            <template slot-scope="scope">
              <span>{{ showPrice[scope.row.SHOW_PRICE] }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="350">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="manager(scope.row)" icon="el-icon-menu">档口管理</el-button>
              <el-button type="text" size="small" @click="projectProduct(scope.row)" icon="el-icon-menu">查看商品</el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" v-if="scope.row.STATUS == 0" disabled
                @click="editUserForm(scope.row)" v-show="customerStatus !== 1">
                修改
              </el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" v-else @click="editUserForm(scope.row)"
                v-show="customerStatus !== 1">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-menu" @click="editChange(scope.row)">修改扣点</el-button>
              <el-button type="text" size="small" icon="el-icon-check" v-if="scope.row.STATUS == 0"
                style="color: rgb(103, 194, 58)" @click="startProject(scope.row)" v-show="customerStatus !== 1">启用
              </el-button>
              <el-button type="text" size="small" icon="el-icon-close" v-else @click="stopProject(scope.row)"
                style="color: rgb(245, 108, 108)" v-show="customerStatus !== 1">禁用</el-button>
              <el-button type="text" size="small" @click="openCheck(scope.row)">检测报告</el-button>
              <el-button type="text" size="small" @click="update(scope.row)" v-show="fun_dic[107000000]">订单价格更新
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block" style="float: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalNum"></el-pagination>
    </div>
    <!-- 新增项目点模态框 -->
    <el-dialog :title="dialogTitle" center :visible.sync="addFormVisible" width="500px">
      <el-form size="small" :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="NAME">
          <label slot="label">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="addForm.NAME" auto-complete="off" clearable
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)"></el-input>
        </el-form-item>
        <el-form-item label="别名：" :label-width="formLabelWidth" prop="AB_NAME">
          <label slot="label">简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="addForm.AB_NAME" auto-complete="off" clearable
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)"></el-input>
        </el-form-item>
        <!-- <el-form-item label="名称缩写：" :label-width="formLabelWidth" prop="CODE">
          <label slot="label">名称缩写：</label>
          <el-input v-model="addForm.CODE" auto-complete="off" clearable :disabled="flag == 1 ? false : ((customerStatus ==1 || customerStatus == 3) ? true : false)"></el-input>
        </el-form-item> -->
        <el-form-item label="城市：" :label-width="formLabelWidth" prop="city">
          <label slot="label">城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市：</label>
          <el-cascader size="small" :options="options" v-model="addForm.selectedOptions" @change="chooseCity"
            style="width: 100%" clearable
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)">
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" :label-width="formLabelWidth" prop="ADDRESS">
          <label slot="label">详细地址：</label>
          <el-input v-model="addForm.ADDRESS" auto-complete="off" clearable
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)"></el-input>
        </el-form-item>
        <el-form-item v-show="dialogFlag === 1 && (customerStatus === 2 || customerStatus === 3)" label="门店负责人："
          :label-width="formLabelWidth" prop="MANAGER_ID">
          <el-select v-model="addForm.MANAGER_ID" placeholder="请选择负责人" clearable style="width: 100%"
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)">
            <el-option v-for="item in PER_LIST" :key="item.ID" :label="item.NAME + '--' + item.CELLPHONE"
              :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户类型:" :label-width="formLabelWidth" prop="CUSTOMER_TYPE">
          <el-select filterable v-model="addForm.TYPE" placeholder="请选择" clearable @change="$forceUpdate()"
            style="width: 100%" :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)">
            <el-option v-for="item in TypeLists" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣点：" :label-width="formLabelWidth" v-if="dialogTitle == '新增项目点'">
          <el-input v-model="addForm.ADD_POINT" oninput="value=value.replace(/[^0-9.]/g,'')"
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)"></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否为内部部门：" :label-width="formLabelWidth">
          <el-radio v-model="addForm.BE_INNER_DEPARTMENT" label="1">是</el-radio>
          <el-radio v-model="addForm.BE_INNER_DEPARTMENT" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="是否计入销售：" :label-width="formLabelWidth">
          <el-radio v-model="addForm.BE_SALE_COUNT" label="1">是</el-radio>
          <el-radio v-model="addForm.BE_SALE_COUNT" label="0">否</el-radio>
        </el-form-item> -->
        <el-form-item label="是否需要检测报告：" :label-width="formLabelWidth">
          <el-radio v-model="addForm.NEED_FTS" label="1"
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)">是</el-radio>
          <el-radio v-model="addForm.NEED_FTS" label="0"
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)">否</el-radio>
        </el-form-item>
        <el-form-item label="打印是否带价格:" :label-width="formLabelWidth">
          <el-radio v-model="addForm.SHOW_PRICE" label="1"
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)">是</el-radio>
          <el-radio v-model="addForm.SHOW_PRICE" label="0"
            :disabled="flag == 1 ? false : (notJustUsingTheSystemToPlaceOrders ? true : false)">否</el-radio>
        </el-form-item>
        <el-form-item label="收货联系人" :label-width="formLabelWidth" prop="CONSIGNEE_CONTACT_NAME">
          <label slot="label">收货联系人：</label>
          <el-input v-model="addForm.CONSIGNEE_CONTACT_NAME" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人电话:" :label-width="formLabelWidth" prop="CONSIGNEE_TELPHONE">
          <label slot="label">收货人电话：</label>
          <el-input v-model="addForm.CONSIGNEE_TELPHONE" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('addForm')">取 消</el-button>
        <el-button size="small" @click="submitAction('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改扣点 -->
    <el-dialog title="修改扣点" center :visible.sync="changeFormVisible" width="400px">
      <el-form size="small" :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="扣点：" :label-width="formLabelWidths">
          <el-input style="margin-left:13px;width:180px" v-model="addForm.ADD_POINT"
            oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeChange('addForm')">取 消</el-button>
        <el-button size="small" @click="submitChange('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出检测报告 -->
    <el-dialog title="导出检测报告" center :visible.sync="exportCheckVisible" width="400px">
      <el-form size="small" :model="exportCheckForm" ref="exportCheckForm" style="margin-top: 0">
        <el-form-item label="送货日期：">
          <el-date-picker v-model="exportCheckForm.date" type="date" placeholder="选择日期" :clearable="false">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('addForm')">取 消</el-button>
        <el-button size="small" @click="submitExport('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入商品绑定信息 -->
    <el-dialog title="导入商品信息" center :visible.sync="importCommodityFormVisible" width="500px"
      :close-on-click-modal="false">
      <el-form ref="importCommodityForm" v-model="importCommodityForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleCommoditySuccess"
          :on-remove="handleCommodityRemove" :name="this.importCommodityForm.commodityName" multiple
          accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadCommodityTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeImportCommodityForm">取 消</el-button>
        <el-button size="small" :loading="loadImport" @click="submitCommodityEnter">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 订单价格更新 -->
    <el-dialog title="订单价格更新" center :visible.sync="updateFormVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="updateForm" v-model="updateForm" style="padding-left: 30px;">
        <el-form-item label="日期范围：">
          <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            v-model="updateForm.START_END" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: 230px">
          </el-date-picker>
        </el-form-item>
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleUpdateSuccess"
          :on-remove="handleUpdateRemove" :name="'tmp'" accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downloadUpdateTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="updateFormVisible = false">取 消</el-button>
        <el-button size="small" :loading="loadImport" @click="updateOrderPrice">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 匹配项目点 -->
    <el-dialog title="匹配项目点" center :visible.sync="matchProjectDialog" width="400px">
      <el-form size="small" :label-width="formLabelWidths" label-suffix="：">
        <el-form-item label="项目点">
          <el-select v-model="toBeMatchedProjectList" multiple filterable>
            <el-option v-for="{ ID, AB_NAME } in unmatchedProjectList" :value="ID" :label="AB_NAME" :key="ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeMatchProject">取 消</el-button>
        <el-button size="small" @click="submitMatchProject">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  projectList, stopProject, addProject, startProject, exportCheckFun, importCommodityFun, exportProductLists, queryAllPerson,
} from 'api/customerManage';
import { regionData, CodeToText, TextToCode } from 'element-china-area-data';
import { getActionFun } from 'api/login';
import date from '@/assets/common/date';
import { getFormatDay } from '@/assets/common/common';
import http from '@/assets/common/http';
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/assets/plugin/loading/loading';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      flag: 0,
      loading: false,
      loadSearch: false,
      searchForm: {
        STATUS: -1,
      },
      projectSitesListData: [],
      currentPage: 1,
      totalNum: 0,
      pageSize: 10,
      addFormVisible: false,
      changeFormVisible: false,
      addForm: {
        selectedOptions: [],
        CITY: '',
        NEED_FTS: '0',
        SHOW_PRICE: '0',
      },
      formLabelWidth: '150px',
      formLabelWidths: '100px',
      options: regionData,
      dialogFlag: 0,
      dialogTitle: '',
      rules: {
        NAME: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
        AB_NAME: [
          { required: true, message: '请输入客户简称', trigger: 'blur' },
        ],
        // CODE: [
        //   { required: true, message: '请输入首字母缩写', trigger: 'blur' },
        // ],
        TELPHONE: [
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: false, message: '请输入正确的手机号', trigger: 'blur',
          },
        ],
      },
      city: [],
      showDepartment: ['非内部部门', '内部部门'],
      showSell: ['不计入销售', '计入销售'],
      showFTS: ['不需要', '需要'],
      showPrice: ['否', '是'],
      exportCheckForm: {
        date: getFormatDay(1, '-'),
      },
      exportCheckVisible: false,
      customerStatus: Number(sessionStorage.getItem('customerStatus')),
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      loadImport: false,
      importCommodityFormVisible: false,
      importCommodityForm: {
        commodityName: 'tmp',
      },
      fileList: [],
      PER_LIST: [],
      updateFormVisible: false,
      updateForm: {},
      PAGE_ID: '1070000', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 107000000: 0 },
      TypeLists: [
        { label: '内部项目', value: 1 },
        { label: '外部项目', value: 2 },
      ],
      customerTypeLists: ['', '内部项目', '外部项目'],
      customerName: sessionStorage.getItem('customerName') || '',
      matchProjectDialog: false,
      unmatchedProjectList: [],
      toBeMatchedProjectList: [],
      selectedList: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryBeforeFun();
    this.queryTable();
    this.queryAllPer();
  },
  computed: {
    STATUS_LIST() {
      return [{ status: -1, name: '全部' }, { status: 0, name: '禁用' }, { status: 1, name: '在用' }];
    },
    notJustUsingTheSystemToPlaceOrders() {
      return [1, 3].includes(this.customerStatus);
    },
    canSelfEntryOrders() {
      return [2, 3].includes(this.customerStatus);
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedList = val.map(({ ID }) => ID);
    },
    closeMatchProject() {
      this.toBeMatchedProjectList = [];
      this.matchProjectDialog = false;
    },
    async submitMatchProject() {
      if (!this.toBeMatchedProjectList.length) {
        this.$message.show({ text: '请选择要匹配的项目点', type: 'warning' });
        return;
      }
      const errList = [];
      showFullScreenLoading();
      for (const PROJECT_ID of this.toBeMatchedProjectList) {
        try {
          const params = {
            SERVICE_ID: '10017',
            OTYPE: 19,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            TC_ID: Number(sessionStorage.getItem('customerId')),
            PROJECT_ID,
          };
          await http.post(params, { showLoading: false });
        } catch (err) {
          errList.push(err);
        }
      }
      tryHideFullScreenLoading();
      if (errList.length) this.$message.show({ text: errList.toString(), type: 'error' });
      else {
        this.$message.show({ text: '匹配成功', type: 'success' });
        this.closeMatchProject();
      }
      this.queryTable();
    },
    matchProject() {
      const params = {
        SERVICE_ID: '10017',
        OTYPE: 18,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: Number(sessionStorage.getItem('customerId')),
      };
      http.post(params).then((res) => {
        this.unmatchedProjectList = res;
        this.matchProjectDialog = true;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // ------------------------------筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.queryTable();
    },
    // --------------------------拉取数据
    queryTable() {
      const data = {
        TC_ID: sessionStorage.getItem('customerId'),
        STATUS: this.searchForm.STATUS,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        ADD_POINT: sessionStorage.getItem('add_point'),
      };
      if (this.searchForm.NAME) {
        data.PROJECT_NAME = this.searchForm.NAME;
      }
      this.loadSearch = true;
      projectList(data).then((res) => {
        if (res) {
          this.projectSitesListData = res[0].list;
          this.totalNum = res[0].TOTAL_COUNT;
        } else {
          this.projectSitesListData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loadSearch = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.loadSearch = false;
      });
    },
    handleCurrentChange() {
      this.queryTable();
    },
    manager(row) {
      this.$router.push({ name: 'dkList' });
      sessionStorage.setItem('projectId', row.ID);
      sessionStorage.setItem('status', row.STATUS);
      sessionStorage.setItem('projectName', row.NAME);
    },
    // -----------------------------禁用启用
    stopProject(row) {
      this.$confirm('您确定禁用该项目点吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {
          PROJECT_ID: row.ID,
        };
        stopProject(data).then((res) => {
          this.$message.show({ text: '禁用成功', type: 'success' });
          this.queryTable();
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    startProject(row) {
      this.$confirm('您确定启用该项目点吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        const data = {
          PROJECT_ID: row.ID,
        };
        startProject(data).then((res) => {
          this.$message.show({ text: '启用成功', type: 'success' });
          this.queryTable();
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    // ----------------------新增按钮
    openAdd() {
      this.flag = 1;
      this.dialogFlag = 0;
      this.addFormVisible = true;
      this.dialogTitle = '新增项目点';
      this.addForm = {
        NEED_FTS: '0',
        SHOW_PRICE: '0',
      };
      this.addForm.TYPE = 2;
      this.addForm.selectedOptions = [];
    },
    // ---------------------------修改按钮
    editUserForm(row) {
      this.flag = 0;
      this.dialogFlag = 1;
      this.addFormVisible = true;
      this.dialogTitle = '修改项目点';
      this.addForm = { ...row, TYPE: row.CUSTOMER_TYPE };
      // this.addForm.BE_INNER_DEPARTMENT = row.BE_INNER_DEPARTMENT.toString()
      // this.addForm.BE_SALE_COUNT = row.BE_SALE_COUNT.toString()
      this.addForm.NEED_FTS = row.NEED_FTS.toString();
      this.addForm.selectedOptions = [];
      this.addForm.SHOW_PRICE = row.SHOW_PRICE.toString();
      if (row.CITY !== '') {
        const city = row.CITY.split('/');
        this.addForm.selectedOptions.push(TextToCode[city[0]].code);
        this.addForm.selectedOptions.push(TextToCode[city[0]][city[1]].code);
        this.addForm.selectedOptions.push(TextToCode[city[0]][city[1]][city[2]].code);
      }
    },
    // 修改扣点
    editChange(row) {
      this.changeFormVisible = true;
      this.addForm = row;
    },
    closeChange() {
      this.changeFormVisible = false;
    },
    submitChange() {
      if (Number(this.addForm.ADD_POINT) >= 100) {
        this.$message.show({ text: '修改数量不能大于等于100', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10006',
        OTYPE: 8,
        PROJECT_ID: this.addForm.ID,
        GYS_ID: sessionStorage.getItem('tcId'),
        ADD_POINT: this.addForm.ADD_POINT,
      };
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.changeFormVisible = false;
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ----------------------确定按钮
    submitAction(formName) {
      if (this.dialogFlag === 0) {
        this.addProject(1);
      } else {
        this.addProject(3);
      }
    },
    // -------------------------------------新增修改项目点
    addProject(OTYPE) {
      if (this.addForm.NAME == '' || this.addForm.AB_NAME == '') {
        this.$message.show({ text: '信息不能为空', type: 'error' });
        return false;
      }
      this.loading = true;
      const data = {
        TC_ID: sessionStorage.getItem('customerId'),
        NAME: this.addForm.NAME,
        CITY: this.addForm.CITY,
        AB_NAME: this.addForm.AB_NAME,
        // CODE: this.addForm.CODE,
        ADDRESS: this.addForm.ADDRESS,
        // BE_INNER_DEPARTMENT: this.addForm.BE_INNER_DEPARTMENT,
        // BE_SALE_COUNT: this.addForm.BE_SALE_COUNT,
        NEED_FTS: this.addForm.NEED_FTS,
        SHOW_PRICE: this.addForm.SHOW_PRICE,
        TELPHONE: this.addForm.CONSIGNEE_TELPHONE || '',
        CONTACT_NAME: this.addForm.CONSIGNEE_CONTACT_NAME || '',
      };
      if (this.addForm.ADD_POINT) {
        data.ADD_POINT = this.addForm.ADD_POINT;
      }
      if (this.addForm.MANAGER_ID) {
        data.MANAGER_ID = this.addForm.MANAGER_ID;
      }
      if (this.addForm.ID) {
        data.PROJECT_ID = this.addForm.ID;
      }
      if (this.addForm.TYPE) {
        data.CUSTOMER_TYPE = this.addForm.TYPE;
      } else {
        data.CUSTOMER_TYPE = 2;
      }
      // if (this.addForm.CODE) {
      //   const reg = /[\u4E00-\u9FA5]/g;
      //   if (reg.test(this.addForm.CODE)) {
      //     this.$message.show({ text: '请不要输入汉字', type: 'warning' });
      //     document.body.style.cursor = 'default';
      //     return false;
      //   }
      // }

      addProject(data, OTYPE).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.addFormVisible = false;
        this.queryTable();
        this.loading = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.loading = false;
      });
    },
    chooseCity(e) {
      this.city = [];
      e.map((item) => {
        const code = CodeToText[item.toString()];
        this.city.push(code);
      });
      this.addForm.CITY = this.city.join('/');
    },
    openCheck(row) {
      this.exportCheckVisible = true;
      this.exportCheckForm.ID = row.ID;
    },
    submitExport() {
      const data = {
        PROJECT_ID: this.exportCheckForm.ID,
        SEND_DAY: date(this.exportCheckForm.date, '%F'),
      };
      exportCheckFun(data)
        .then((res) => {
          window.location.href = res[0].FILE_PATH;
          this.exportCheckVisible = false;
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    closeExport() {
      this.exportCheckVisible = false;
    },
    projectProduct(row) {
      this.$router.push({ name: 'projectProduct' });
      sessionStorage.setItem('projectId', row.ID);
      sessionStorage.setItem('projectName', row.NAME);
    },
    // 打开商品绑定模态框
    commodityBindForm(row) {
      this.importCommodityFormVisible = true;
      // this.projectID = row.ID
    },
    // 关闭商品绑定模态框
    closeImportCommodityForm() {
      this.importCommodityFormVisible = false;
    },
    // 导入商品绑定的下载模板
    downLoadCommodityTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pm2zzvpp.xlsx';
    },
    handleCommoditySuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleCommodityRemove(file, fileList) {
      this.fileList = [];
    },
    // 导入商品提交
    submitCommodityEnter() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: Number(sessionStorage.getItem('customerId')),
            FILE_NAME: this.file_name,
            DET_PROJECT_LIST: this.selectedList,
          };
          this.loadImport = true;
          importCommodityFun(params).then((result) => {
            if (result[0].FILE_PATH == '') {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.selectedList = [];
            } else {
              this.$message.show({ text: '部分导入失败，请注意下载文件', type: 'error' });
              window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
            }
            this.fileList = [];
            this.queryTable();
            this.loadImport = false;
            this.importCommodityFormVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.loadImport = false;
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // 导出
    exportProject() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('customerId')),
      };
      exportProductLists(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 拉取门店联系人
    queryAllPer() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('customerId')),
      };
      queryAllPerson(params).then((result) => {
        this.PER_LIST = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 订单价格更新
    update(row) {
      this.updateFormVisible = true;
      this.updateForm = { ...row };
    },
    // 订单价格更新的下载模板
    downloadUpdateTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/updateOrderPriceTemplate.xlsx';
    },
    handleUpdateSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleUpdateRemove(file, fileList) {
      this.fileList = [];
    },
    updateOrderPrice() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10006',
            OTYPE: 9,
            GYS_ID: sessionStorage.getItem('tcId'),
            PROJECT_ID: this.updateForm.ID,
            TC_ID: Number(sessionStorage.getItem('customerId')),
            FILE_NAME: this.file_name,
          };
          if (this.updateForm.START_END && this.updateForm.START_END[0]) {
            params.START_DAY = this.updateForm.START_END[0];
            params.END_DAY = this.updateForm.START_END[1];
          } else {
            this.$message.show({ text: '必须选择订单价格更新的日期范围', type: 'warning' });
          }
          this.loadImport = true;
          http.post(params)
            .then((result) => {
              if (result[0].FILE_PATH == '') {
                this.$message.show({ text: '导入成功', type: 'success' });
              } else {
                window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              }
              this.fileList = [];
              this.queryTable();
              this.loadImport = false;
              this.updateFormVisible = false;
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.loadImport = false;
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/projectList.vue